import { DynamicLoad } from '@/_cactus_core/build/dynamicLoad';





import ad02eca16fcd46646dfcf8f7d80a15ed8b from "./generated-10b4b157-e54d-44b9-a8d2-3fef27eca889.json";

import aa626aedf8cf08d79788e2e8c841eff83b from "./generated-51d05cf6-567f-471c-af18-d7848d07cdf4.json";

import ab28007ff93f4b91328503c40bf48a8f5b from "./generated-9b9b3205-bddd-4ae0-9aad-8f0cee611227.json";

import af8c3bc3918b68a4b91d8c722466c59c7b from "./generated-dcf6b069-3845-4300-aef2-b5316816dd3e.json";

import a0fab3010701903fec39d0ab1757add3eb from "./generated-79f87d77-e5d1-4444-8a5a-ee5ead6fcc90.json";

import a13f253c9230a5162de5c94c24ba747e0b from "./generated-4f5d39f0-06a4-4f90-90b9-df60c5fcabb9.json";

import ad4de44e63a0ba2f0d453467bea377f06b from "./generated-1439daad-7781-471d-b4df-31823bc840f5.json";

import a34a8ee1ba9f7470bf8c80707a319ccc0b from "./generated-640a79b7-90f4-454e-a260-6fad07eb800a.json";

import a77405c372102711eda17a5aa7988b918b from "./generated-1b61afcf-8182-4136-bfc5-664defe5799e.json";

import ac7d14f74eadb2def6b139f43769cdd24b from "./generated-fab98732-5037-4606-b64a-660d6fb26602.json";

import adcfaf9b4e4ea56f1494543878f34aa4eb from "./generated-341cfbce-7357-4657-adcf-7ccd96fe608c.json";

import aa754447044ed6e3a6b2240fe09357ecfb from "./generated-ab2a3e42-a7c1-4b52-87ad-5155ff662df2.json";

import a984bb07c3a09dfa243bb277a2c84f7a0b from "./generated-f76be698-f8ce-4753-b521-c6f4e07556fc.json";

import a7983f42f9e378e13edce289da01a9c6cb from "./generated-bc571f3b-15fd-4058-928b-e9bf413d9a31.json";

import a03ef5bddb168a2a3385164328060d9ffb from "./generated-0665dc63-308c-4537-a8a4-171d9de742b0.json";

import a785dd80b9b63d058aa1f347d09516547b from "./generated-8483ad5c-3215-4e04-98fc-01f2f0e4e7ce.json";

import a0472d3271c0e830e946138dcef437f29b from "./generated-9dcd0986-e9d6-40a6-b862-d9f6bb67d751.json";

import a9bc7f8518f5bb14034dad69487f44c42b from "./generated-72f0e2dd-03ec-485e-8109-a02a74f34069.json";

import a296b97c2e46b896c389ab30989a2b57eb from "./generated-158a937f-22e5-4be3-9b6f-758634c1b936.json";





/* eslint-disable */

export default async function(url) {
  let storeData = false;

  async function direct(jsonResult) {
    return new Promise(async function(done,err) {
      try {
        storeData = {
          headers: jsonResult.headers,
          data: jsonResult.data,
        };
        
        done(storeData);
      } catch(e) {
        err(e);
      }
    });
  }

  async function ok(cachedJson) {
    return new Promise(async function(done,err) {
      try {
        const jsonResult = await DynamicLoad(cachedJson);

        storeData = {
          headers: jsonResult.headers,
          data: jsonResult.data,
        };

        done(storeData);
      } catch(e) {
        err(e);
      }
    });
  }
  
  try {
  
  




         if(url === "/api/appearance"){
            
                    await direct(ad02eca16fcd46646dfcf8f7d80a15ed8b);
                
        }
    


        else if(url === "/api/getlegalterm"){
            
                    await direct(aa626aedf8cf08d79788e2e8c841eff83b);
                
        }
    


        else if(url === "/api/country"){
            
                    await direct(ab28007ff93f4b91328503c40bf48a8f5b);
                
        }
    


        else if(url === "/api/crypto/all"){
            
                    await direct(af8c3bc3918b68a4b91d8c722466c59c7b);
                
        }
    


        else if(url === "/api/bff/features"){
            
                    await direct(a0fab3010701903fec39d0ab1757add3eb);
                
        }
    


        else if(url === "/api/payment-providers"){
            
                    await direct(a13f253c9230a5162de5c94c24ba747e0b);
                
        }
    


        else if(url === "/api/bff/games/top-wins"){
            
                    await direct(ad4de44e63a0ba2f0d453467bea377f06b);
                
        }
    


        else if(url === "/api/bff/games/last-wins"){
            
                    await direct(a34a8ee1ba9f7470bf8c80707a319ccc0b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-da-pg&per_page=15"){
            
                    await direct(a77405c372102711eda17a5aa7988b918b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=roleta&per_page=16"){
            
                    await direct(ac7d14f74eadb2def6b139f43769cdd24b);
                
        }
    


        else if(url === "/api/undefined&per_page=undefined"){
            
                    await direct(adcfaf9b4e4ea56f1494543878f34aa4eb);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-crash&per_page=15"){
            
                    await direct(aa754447044ed6e3a6b2240fe09357ecfb);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-de-aventura&per_page=15"){
            
                    await direct(a984bb07c3a09dfa243bb277a2c84f7a0b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=cassino-ao-vivo&per_page=15"){
            
                    await direct(a7983f42f9e378e13edce289da01a9c6cb);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=slots&per_page=15"){
            
                    await direct(a03ef5bddb168a2a3385164328060d9ffb);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-novos&per_page=15"){
            
                    await direct(a785dd80b9b63d058aa1f347d09516547b);
                
        }
    


        else if(url === "/api/casino-games/filter?per_page=1&per_page=15"){
            
                    await direct(a0472d3271c0e830e946138dcef437f29b);
                
        }
    


        else if(url === "/api/casino-games/filter?providers[]=hacksaw&per_page=15"){
            
                    await direct(a9bc7f8518f5bb14034dad69487f44c42b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=blackjack&per_page=15"){
            
                    await direct(a296b97c2e46b896c389ab30989a2b57eb);
                
        }
    


        else if(url === "/api/casino-games/filter?categories%5B%5D=all"){
            
                    await direct(a0472d3271c0e830e946138dcef437f29b);
                
        }
    





  } catch(ex){
    console.log('failed to get cache',ex,url);
  }

  return storeData;
};

/* eslint-enable */